import React from "react";
import serviceIcon1 from "../../assets/images/services/service-icon1.png";
import serviceIcon2 from "../../assets/images/services/service-icon2.png";
import serviceIcon3 from "../../assets/images/services/service-icon3.png";
import serviceIcon4 from "../../assets/images/services/service-icon4.png";

const ManualCalc = () => {
  const disadvantages = [
    {
      title: "薪酬规则",
      desc: "预置方案+灵活自定义薪酬核算方式",
      icon: serviceIcon1,
    },
    {
      title: "薪酬变动",
      desc: "查询、审批、批量调整",
      icon: serviceIcon2,
    },
    {
      title: "工资发放",
      desc: "自动核算，台账清晰",
      icon: serviceIcon3,
    },
    { title: "社保公积金", desc: "自动生成社保缴交数据", icon: serviceIcon4 },
  ];

  return (
    <section className="services-area ptb-70 bg-f1f8fb">
      <div className="container">
        <div className="section-title">
          <h2>你还在手动计算薪酬？</h2>
        </div>

        <div className="row">
          {disadvantages.map(({ title, desc, icon }, key) => (
            <div className="col-lg-3 col-sm-6">
              <div className="single-services-item-box">
                <div className="icon">
                  <img src={icon} alt="feature" />
                </div>
                <h3>{title}</h3>
                <p style={{ height: "4rem" }}>{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManualCalc;
